import { render, staticRenderFns } from "./CreateOrganizationPromoters.vue?vue&type=template&id=70b81247&scoped=true"
import script from "./CreateOrganizationPromoters.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrganizationPromoters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateOrganizationPromoters.vue?vue&type=style&index=0&id=70b81247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b81247",
  null
  
)

export default component.exports